import { render } from "./GrLayout.vue?vue&type=template&id=c8f70ce2&scoped=true"
import script from "./GrLayout.vue?vue&type=script&lang=js"
export * from "./GrLayout.vue?vue&type=script&lang=js"

import "./GrLayout.vue?vue&type=style&index=0&id=c8f70ce2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8f70ce2"]])

export default __exports__